module.exports = __webpack_public_path__ + "img/woman-business.e54e1a64.png";